// 音频按钮
<template>
    <div class="audioButton">
        <div
        :class="['music',{music1: auidoStateArr[0]}]"
        @click="audioButtonClick(0)"
        v-if="option.isMusicShow"
        >
            <img src="@/assets/svg/music.svg">
        </div>
        <div
        :class="['sound',{sound1: auidoStateArr[1]}]"
        @click="audioButtonClick(1)"
        v-if="option.isSoundShow"
        >
        <img src="@/assets/img/sound.png" v-if="!auidoStateArr[1]">
        <img src="@/assets/img/sound_active.png" v-if="auidoStateArr[1]">
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let audioState = createNamespacedHelpers("audioState");
export default {
    data() { 
        return {
            flag: false
        }
    },
    beforeDestroy(){
        if(this.auidoStateArr[1]){
            this.setAudioArr({
                index: 2,
                flag: false,
            });
            if(this.auidoStateArrCopy[0]){
                this.setAudioArr({
                    index: 0,
                    flag: true,
                });
            }
        }
        
        
    },
    methods: {
        audioButtonClick(index){
            this.setAudioArr({
                index: index,
                flag: this.auidoStateArr[index]?false:true,
            });
        },
        ...audioState.mapMutations(["setAudioArr"]),
    },
    props: {
        option: Object
    },
    computed: {
        ...audioState.mapState(["auidoStateArr","auidoStateArrCopy"]),
    },
}
</script>

<style lang="scss" scoped>
@keyframes circling {
    0%{
        transform: rotate(0);
    }
    100%{
        transform: rotate(360deg);
    }
}
.audioButton{
    .music,.sound{
        width: .5rem;
        height: .5rem;
        position: absolute;
        right: .3rem;
        top: .32rem;
        z-index: 2;
        border-radius: 50%;
        background: rgba(0,0,0,.4);
        &.sound{
            top: 1.3rem;
        }
        &.music1{
            animation: circling 5s linear 0s infinite;
        }
    }
}
</style>